<template>
  <main class="pt-16 bg-gradient-to-b from-gray-100 via-gray-200 to-gray-100 min-h-screen flex items-center justify-center">
    <div class="text-center px-4 sm:px-6">
      <h1 class="text-7xl sm:text-8xl lg:text-9xl font-bold text-gray-300">404</h1>
      <h2 class="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mt-4 mb-4">
        Page non trouvee
      </h2>
      <p class="text-gray-600 text-sm sm:text-base mb-6 sm:mb-8 max-w-md mx-auto">
        Desolee, la page que vous recherchez n'existe pas ou a ete deplacee.
      </p>
      <router-link
        to="/"
        class="inline-block bg-black hover:bg-gray-800 text-white font-semibold py-3 px-6 sm:px-8 rounded-lg transition-colors text-sm sm:text-base"
      >
        Retour a l'accueil
      </router-link>
    </div>
  </main>
</template>

<script>
export default {
  name: "NotFoundView",
};
</script>
